import { Box, styled } from '@mui/material';

import { getShouldForwardPropFn } from '@mopla/utils';

const RPA_ELEVATION_3 = '10px 10px 10px -4px rgba(24, 39, 75, 0.12)';

export const ROTATING_GRADIENT_GLOBAL_STYLES = `
@property --rhs-border-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}
@keyframes rhs-border-angle-rotate {
  to {
    --rhs-border-angle: 360deg;
  }
}
`;

export const RotatingGradientLayer = styled(Box)(({ theme }) => ({
	position: 'absolute',
	inset: '-2px',
	borderRadius: 10,
	pointerEvents: 'none',
	zIndex: 0,
	background:
		'conic-gradient(from calc(90deg + var(--rhs-border-angle)), var(--rhs-primary), var(--rhs-primary800), var(--rhs-myway), var(--rhs-primary))',
	animation: 'rhs-border-angle-rotate 3s linear infinite',

	'--rhs-primary': theme.palette.primary.main,
	'--rhs-primary800': theme.palette.primary[800] ?? '#1C2F87',
	'--rhs-myway': theme.palette.myway?.[200],
}));

export const ContentLayer = styled(Box)(({ theme }) => ({
	position: 'relative',
	zIndex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'flex-start',
	padding: 12,
	borderRadius: 8,
	backgroundColor: theme.palette.neutral.main,
	boxShadow: RPA_ELEVATION_3,
	cursor: 'pointer',
}));

export const Container = styled(Box, {
	shouldForwardProp: getShouldForwardPropFn(
		'selected',
		'disableBorder',
		'disableInteraction'
	),
})<{
	selected: boolean;
	disableBorder?: boolean;
	disableInteraction?: boolean;
}>(({ theme, selected, disableBorder, disableInteraction }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'flex-start',
	padding: 12,
	borderRadius: 8,
	cursor: disableInteraction ? 'default' : 'pointer',
	pointerEvents: disableInteraction ? 'none' : undefined,
	position: 'relative',
	overflow: 'hidden',
	scrollSnapAlign: 'start',
	backgroundColor: theme.palette.neutral.main,
	border: disableBorder
		? 'none'
		: selected
		? '1px solid transparent'
		: `0.5px solid ${theme.palette.solutions?.[600]}`,
	...(selected &&
		!disableBorder && {
			background:
				'linear-gradient(#fff, #fff) padding-box, linear-gradient(120deg, #0E1C5B, #1C2F87, #A7BEF1) border-box',
			boxShadow: RPA_ELEVATION_3,
		}),
}));
